export default "__VITE_ASSET__rKea3OAS__"